// Angular
import { Component, ViewChild, ElementRef, Input, AfterViewInit, OnChanges,Renderer2, ChangeDetectorRef, HostListener } from '@angular/core';
// Layout
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UserData } from 'src/app/Services/data.model';
import { ApiService } from 'src/app/Services/api.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { Router } from '@angular/router';
import { AdmissionApiService } from 'src/app/Services/admission.service';
import { DoCheck } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { TemplatesService } from 'src/app/Services/templates.service';
import { EditTransactionComponent } from 'src/app/components/pages/fee/transactionList/editTransaction/editTransaction.component';
import { OtherApiService } from 'src/app/Services/other.service';
import { FeeApiService } from 'src/app/components/pages/fee/feeApi.service';
import { EditAdmissionTransactionComponent } from 'src/app/components/pages/admission/transaction/editAdmissionTransaction/editAdmissionTransaction.component';
import { ProfileApiService } from 'src/app/Services/profile.service';

@Component({
	selector: 'kt-quick-panel',
	templateUrl: './quick-panel.component.html',
	styleUrls: ['./quick-panel.component.scss']
})
export class QuickPanelComponent  {
	// Public properties
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('selectSession', { static: false }) selectSession: ElementRef;
	  @ViewChild('paginator1', {static: true}) paginator1: MatPaginator;
	  @ViewChild('paginator2', {static: true}) paginator2: MatPaginator;
	  @ViewChild('paginator3', {static: true}) paginator3: MatPaginator;
	  @ViewChild(MatSort, {static: true}) sort1: MatSort;
	  @ViewChild('panelContent', { static: false }) panelContent: ElementRef;
	  @ViewChild('panelContent2', { static: false }) panelContent2: ElementRef;
	@Input() data;
	@Input() flag;
	@Input() regNo;
	@Input() admissionStudentData;
	@Input() dossier;
	@Input() selectedSession;
	@Input() sessionList;
	@Input() type;
	@Input() admissionStudentId;
  
	permissions = localStorage.getItem('permissions');
	entityId = localStorage.getItem('entityId');
	entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
	session = localStorage.getItem('session');
	
	displayedColumns = ['document', 'action', 'receiptId', 'date', 'paymentMode', 'refId', 'remark', 'totalPaidAmount', 'status', 'bankName'];
	displayedColumns1 = ['receiptId', 'date', 'paymentMode', 'refId', 'remark', 'totalPaidAmount', 'status'];
	onlineDisplayedColumns = ['sno', 'onlineAction', 'receipt', 'user', 'student', 'course', 'date2', 'settlementDate', 'installmentAmount', 'paidAmount', 'onlineStatus'];
	
	dataSource = new MatTableDataSource<UserData>();
	dataSource1 = new MatTableDataSource<UserData>();
	dataSource2 = new MatTableDataSource<any>();
	
	isFeesTabActive = true;
	isRefundFeeActive = true;
	hasError = false;
	hasFormErrors = false;
	hasSuccess = false;
	loading = false;
	showTable = false;
	admissionFlag = false;
	primaryColour: string;
	
	statusList = ['confirmed', 'cancelled'];
	status: any;
	startDate: any;
	endDate: any;
	search: any;
	studentId: any;
	originalFlag: any;
	pageNumber: any;
	endDatepageSize: any;
	selectedHtmlTemplate: any;
	templateList: any;




	offcanvasOptions: OffcanvasOptions = {
	  overlay: true,
	  baseClass: 'kt-quick-panel',
	  closeBy: 'kt_quick_panel_close_btn',
	  toggleBy: 'kt_quick_panel_toggler_btn',
	};
	hasError1: boolean=false;
	hasError2: boolean=false;
	dataLoaded: boolean = false; // Flag to prevent automatic API calls on initialization
	panelOpened: boolean = false; // Flag to track if Payment History button has been clicked
	fetchDataInProgress: boolean = false; // Flag to prevent duplicate fetchData calls
	transactionApiCompleted: boolean = false; // Track if transaction API completed
	refundApiCompleted: boolean = false; // Track if refund API completed
	onlineApiCompleted: boolean = false; // Track if online transactions API completed
	loadingOnlineStatus: { [id: string]: boolean } = {}; // Per-row spinner for Check Status (TC-04)
  
	constructor(
	  private service: ProfileApiService,
	  private dialog: MatDialog,
	  private templateService: TemplatesService,
	  private util: UtilsService,
	  private router: Router,
	  private admissionApiService: AdmissionApiService,
	  private renderer: Renderer2,
	  private ref: ChangeDetectorRef,
	  private feeService: FeeApiService
	) { }

	
	   
   
	ngOnInit() {
	  this.renderer.addClass(document.body, 'paymentHistoryPanel');
	  this.selectedSession = this.selectedSession || this.session;
	  this.primaryColour = this.service.passColour();
	  this.setColumns();
	  this.studentId = this.data;
	  // Do not call fetchData() here - APIs will be called only when Payment History button is clicked
	  
	  // Listen for toggle button clicks to detect when panel opens
	  // This handles the case when panel is opened via toggle button (e.g., from studentData page)
	  // Note: For studentProfile page, fetchData() is called directly from scrollToTop(), so we check flags to avoid duplicate calls
	  setTimeout(() => {
		const toggleBtn = document.getElementById('kt_quick_panel_toggler_btn');
		if (toggleBtn) {
		  toggleBtn.addEventListener('click', () => {
			// Small delay to ensure panel is opening, then check if it's open
			setTimeout(() => {
			  const panelElement = document.getElementById('kt_quick_panel');
			  if (panelElement && panelElement.classList.contains('kt-quick-panel--on')) {
				// Panel is now open - call fetchData() if it hasn't been called yet for this session/student
				// This handles multiple rows correctly. 
				if (!this.fetchDataInProgress) {
				  this.fetchData();
				} else {
				  this.scrollToTop();
				}
			  }
			}, 200);
		  });
		}
	  }, 500);
	}
  
	ngOnChanges(changes: SimpleChanges) {
	  // Only update properties, do not call APIs automatically
	  if (changes.flag) {
		this.originalFlag = JSON.parse(JSON.stringify(this.flag));
	  }
	  if (changes.regNo && changes.regNo.currentValue) {
		this.regNo = changes.regNo.currentValue;
	  }
	  if (changes.data) {
		const newStudentId = (this.data && typeof this.data === 'object' && this.data._id) ? this.data._id : this.data;
		if (newStudentId !== this.studentId) {
			this.studentId = newStudentId;
			this.dataSource.data = [];
			this.dataSource1.data = [];
			this.dataSource2.data = [];
			if (this.panelOpened) {
				this.fetchDataInProgress = false;
				this.fetchData();
			}
		}
	  }
	  if (changes.selectedSession) {
		const newSession = changes.selectedSession.currentValue;
		if (newSession && newSession !== this.selectedSession) {
			this.selectedSession = newSession;
			if (this.panelOpened) {
				this.fetchDataInProgress = false;
				this.fetchData();
			}
		} else if (newSession) {
			this.selectedSession = newSession;
		}
	  }
	  this.setPaginator();
	  // APIs will be called only when Payment History button is clicked via fetchData()
	}
  
	setColumns() {
	  if (this.entityPreferences.editFeeDocument) {
		this.displayedColumns = ['action', 'document', 'status', 'receiptId', 'date', 'paymentMode', 'refId', 'remark', 'totalPaidAmount', 'bankName'];
	  } else {
		this.displayedColumns = ['action', 'status', 'receiptId', 'date', 'paymentMode', 'refId', 'remark', 'totalPaidAmount', 'bankName'];
	  }
	}
  
	fetchData() {
		if (!this.flag) return;
	  
		// Extract studentId properly from data if not already set (e.g. from fetchStudentId)
		if (!this.studentId && this.data) {
			this.studentId = (typeof this.data === 'object' && this.data._id) ? this.data._id : this.data;
		}
	  
		// Prevent duplicate calls - if fetchData is already in progress, return
		if (this.fetchDataInProgress) return;
	  
		// Mark that fetchData is in progress
		this.fetchDataInProgress = true;
	  
		// Mark that panel has been opened (allows API calls)
		this.panelOpened = true;
		this.dataLoaded = true;
	  
		// Reset API completion flags
		this.transactionApiCompleted = false;
		this.refundApiCompleted = false;
		this.onlineApiCompleted = false;
	  
		// Set loading to true to show loader
		this.loading = true;
		this.hasError = false;
		this.hasError1 = false;
	  
		if (this.flag === 'admission') {
			if(this.studentId!=undefined && this.studentId!=null && this.studentId!=''){
		  this.listAdmissionTransaction(this.studentId, this.selectedSession);
		  this.listAdmissionRefundTransactions(this.studentId);
			} else {
		  this.loading = false;
			}
		} else {
			if(this.studentId!=undefined && this.studentId!=null && this.studentId!=''){
		  this.listTransactions(this.studentId);
		  this.listRefundTransactions(this.studentId);
			} else {
		  this.loading = false;
			}
		}
		// Always fetch online transactions if regNo is available
		if (this.regNo) {
			this.getOnlineTransactions();
		} else {
			this.onlineApiCompleted = true;
		}
		
		// Reset the flag after a short delay to allow for future calls
		setTimeout(() => {
		  this.fetchDataInProgress = false;
		}, 1000);
	  }
	  
	  scrollToTop() {
		// Scroll the panel content to top - use longer delay to ensure DOM is ready
		setTimeout(() => {
		  // Scroll first content area (payment history)
		  if (this.panelContent && this.panelContent.nativeElement) {
			this.panelContent.nativeElement.scrollTo({
			  top: 0,
			  behavior: 'smooth'
			});
		  }
		  // Scroll second content area (refund transactions)
		  if (this.panelContent2 && this.panelContent2.nativeElement) {
			this.panelContent2.nativeElement.scrollTo({
			  top: 0,
			  behavior: 'smooth'
			});
		  }
		  // Also scroll the main panel element
		  const panelElement = document.getElementById('kt_quick_panel');
		  if (panelElement) {
			panelElement.scrollTo({
			  top: 0,
			  behavior: 'smooth'
			});
		  }
		  // Also scroll window to top (for student profile page)
		  if (window.parent) {
			window.parent.scrollTo({
			  top: 0,
			  behavior: 'smooth'
			});
		  }
		}, 300);
	  }
	  
	onSessionChange(item,event)
	{
		// Only process session changes if panel has been opened (button clicked)
		if(event.isUserInput && this.panelOpened)
		{
			this.selectedSession = item;
			this.fetchStudentId(item) //to get id from previous session
		}
	}
	fetchStudentId(session) 
	{
		// Only fetch if panel has been opened
		if (!this.panelOpened) return;
		
		this.loading = true;
		this.hasError = false;
		this.hasError1 = false;
		this.fetchDataInProgress = false;

		this.service.fetchStudentId(this.entityId,session,this.regNo)
		.subscribe(res=>{
			if (res && res._id) {
				this.studentId = res._id;
				this.fetchData();
			} else {
				this.studentId = null;
				this.dataSource.data = [];
				this.dataSource1.data = [];
				this.dataSource2.data = [];
				this.hasError = true;
				this.hasError1 = true;
				this.hasError2 = true;
				this.loading = false;
				this.ref.detectChanges();
			}
		},err=>{
			this.studentId = null;
			this.dataSource.data = [];
			this.dataSource1.data = [];
			this.dataSource2.data = [];
			this.hasError = true;
			this.hasError1 = true;
			this.hasError2 = true;
			this.loading = false;
			this.ref.detectChanges();
		})
	}
	listTransactions(id) {
	  // Only allow API calls if panel has been opened via button click
	  if (!this.panelOpened) return;
	  
	  // Note: loading is already set in fetchData(), don't set it again here
	  this.isFeesTabActive = true;
	  let formData:any={
		entity:this.entityId,
		session:this.selectedSession,
		startDate:this.startDate,
		endDate:this.endDate,
		status:this.status,
		search:this.search,
		student:id
	  }
	  this.service.listStudentTransaction(formData)
		.subscribe(res => {
		  this.processTransactionData(res);
		}, () => this.handleError());
	}
  
	listRefundTransactions(id) {
	  // Only allow API calls if panel has been opened via button click
	  if (!this.panelOpened) return;
	  
	  // Note: loading is already set in fetchData(), don't set it again here
	  this.isRefundFeeActive = true;

	  let userPrefStr = localStorage.getItem('userPreferences') || '{}';
	  let userPref: any = {};
	  try { userPref = JSON.parse(userPrefStr); } catch(e) {}
	  let prefCourses = userPref['courses'] ? userPref['courses'] : null;

	  this.service.listRefundTransaction(this.entityId, this.selectedSession, this.startDate, this.endDate, this.status, this.search, this.pageNumber, this.endDatepageSize, id, undefined, prefCourses)
		.subscribe(res => {
		  this.processRefundData(res);
		}, () => this.handleError());
	}
  
	listAdmissionTransaction(id, session) {
	  // Only allow API calls if panel has been opened via button click
	  if (!this.panelOpened) return;
	  
	  // Note: loading is already set in fetchData(), don't set it again here
	  this.isFeesTabActive = false;
	  this.admissionApiService.viewAdmissionTransactionList(this.entityId, session, id)
		.subscribe(res => {
		  this.processTransactionData(res, true);
		}, () => this.handleError());
	}
		listAdmissionData(data) {
		// Only allow API calls if panel has been opened via button click
		if (!this.panelOpened) return;
		
		this.isFeesTabActive = false;
		this.listAdmissionTransaction(data, this.selectedSession);
	}

	listAdmissionRefundTransactions(id) {
	  // Only allow API calls if panel has been opened via button click
	  if (!this.panelOpened) return;
	  
	  // Note: loading is already set in fetchData(), don't set it again here
	  this.isRefundFeeActive = false;
	  this.service.listAdmissionRefundTransaction(this.entityId, this.selectedSession, this.startDate, this.endDate, this.status, this.search,this.pageNumber, this.endDatepageSize,id,undefined)
		.subscribe(res => {
		  this.processRefundData(res);
		}, () => this.handleError());
	}
  
	processTransactionData(res, isAdmission = false) {
	  this.hasError = res.length < 1;
	  this.dataSource.data = res;
	  this.admissionFlag = isAdmission;
	  this.transactionApiCompleted = true;
	  
	  // Check if all APIs are completed before hiding loader
	  if (this.refundApiCompleted && this.onlineApiCompleted) {
		this.checkAllApisComplete();
	  } else {
		this.ref.detectChanges();
	  }
	}
  
	processRefundData(res) {
	  this.hasError1 = res.length < 1;
	  this.showTable = res.length > 0;
	  this.dataSource1.data = res;
	  this.refundApiCompleted = true;
	  
	  // Check if all APIs are completed before hiding loader
	  if (this.transactionApiCompleted && this.onlineApiCompleted) {
		this.checkAllApisComplete();
	  } else {
		this.ref.detectChanges();
	  }
	}
  
	handleError() {
	  // Mark APIs as completed on error
	  if (!this.transactionApiCompleted) {
		this.transactionApiCompleted = true;
		this.hasError = true;
	  }
	  if (!this.refundApiCompleted) {
		this.refundApiCompleted = true;
		this.hasError1 = true;
	  }
	  if (!this.onlineApiCompleted) {
		this.onlineApiCompleted = true;
		this.hasError2 = true;
	  }
	  
	  // Hide loader if all APIs are done (either success or error)
	  if (this.transactionApiCompleted && this.refundApiCompleted && this.onlineApiCompleted) {
		this.loading = false;
		this.ref.detectChanges();
		// Scroll to top even on error
		setTimeout(() => {
		  this.scrollToTop();
		}, 200);
	  } else {
		this.ref.detectChanges();
	  }
	}

	getOnlineTransactions() {
	  if (!this.panelOpened || !this.regNo) {
		this.onlineApiCompleted = true;
		return;
	  }
	  const formData: any = {
		entity: this.entityId,
		regNo: this.regNo
	  };
	  this.feeService.getTransactionList(formData).subscribe(res => {
		this.hasError2 = !res || res.length < 1;
		if (res && res.length > 0) {
			this.util.arrayReverseSort(res, 'date');
		}
		this.dataSource2.data = res || [];
		this.onlineApiCompleted = true;
		this.checkAllApisComplete();
		this.ref.detectChanges();
	  }, () => {
		this.hasError2 = true;
		this.onlineApiCompleted = true;
		this.checkAllApisComplete();
		this.ref.detectChanges();
	  });
	}

	updateOnlineTransactionStatus(row) {
	  if (this.loadingOnlineStatus[row._id]) return; // TC-04: prevent double click
	  this.loadingOnlineStatus[row._id] = true;
	  this.ref.detectChanges();
	  this.feeService.updateStatus(row).subscribe(res => {
		setTimeout(() => {
		  if (res.status === 'paid') {
			this.util.alertNotificationMessage('Payment is now confirmed by the bank');
		  } else if (res.status === 'refund') {
			this.util.alertNotificationMessage('Your payment has been refunded. Please allow some time for the amount to reflect in your account.');
		  } else {
			this.util.alertNotificationMessage('Payment status is still awaited from the bank. Kindly do not pay again if payment is deducted.');
		  }
		  this.loadingOnlineStatus[row._id] = false;
		  this.getOnlineTransactions();
		  this.ref.detectChanges();
		}, 3000);
	  }, err => {
		setTimeout(() => {
		  this.loadingOnlineStatus[row._id] = false;
		  this.ref.detectChanges();
		}, 1000);
		this.util.errmsg(err);
	  });
	}

	checkAllApisComplete() {
	  if (this.transactionApiCompleted && this.refundApiCompleted && this.onlineApiCompleted) {
		this.loading = false;
		this.ref.detectChanges();
		setTimeout(() => {
		  this.scrollToTop();
		}, 200);
	  }
	}
	cancelReceipt(receipt){
		if(receipt.student && receipt.student.extraFeeCarriedNextSession)
		{
			this.util.alertNotificationMessage('Receipt cancellation not allowed. Adjustment entry has been moved to another session');
			return;
		}
		const dialogRef = this.dialog.open(EditTransactionComponent, { data: { receipt } });
			dialogRef.afterClosed().subscribe(res => {
				if (!res.isEdit) {
					return;
		  }
        this.listTransactions(this.studentId)
		});

	  }
	cancelAdmissionReceipt(receipt){
		const dialogRef = this.dialog.open(EditAdmissionTransactionComponent, { data: { receipt } });
			dialogRef.afterClosed().subscribe(res => {
				if (!res.isEdit) {
					return;
		  }
        this.listAdmissionTransaction(this.studentId,this.selectedSession)
		});

	  }
	viewTransection(id,row){
		let sessionVal = this.selectedSession || row.session;
		if(this.flag =="studentProfile"){
			if(this.admissionFlag){
			this.router.navigate(['/print/open/printAdmissionTransaction/'+ id , {prev:'/student/studentProfile/'+this.studentId, regNo: this.regNo, prevName:'Student Profile',course:row.applicationDetails.course, session: sessionVal}]);
			}else{
				this.printSelectedTemplate(row)
				//this.router.navigate(['/print/open/printReceipt/'+ id , {prev:'/student/studentProfile/'+this.studentId, regNo: this.regNo, prevName:'Student Profile'}]);			}
			}
		}
		if(this.flag =="feeProfile"){
			if(this.admissionFlag){
					this.router.navigate(['/print/open/printAdmissionTransaction/'+ id , {prev:'/fee/feeProfile/'+this.studentId, regNo: this.regNo, prevName:'Fee Profile',course:row.applicationDetails.course,type:this.type, session: sessionVal}]);
			}else{
				this.router.navigate(['/print/open/printReceipt/'+ row._id , {prev:'/fee/feeProfile/'+this.studentId, regNo: this.regNo, prevName:'Fee Profile',course:row.studentDetails.course,type:this.type, session: sessionVal}]);
				return;
			}
		}
		if(this.flag == "admission"){
			if(this.originalFlag == this.flag){
			this.router.navigate(['/print/open/printAdmissionTransaction/'+ id , {prev:'/admission/studentData', prevName:'Admission Application Data',course:row.applicationDetails.course, session: sessionVal}]);
			}else if(this.originalFlag === 'studentProfile'){
				this.router.navigate(['/print/open/printAdmissionTransaction/'+ id , {prev:'/student/studentProfile/'+this.studentId, regNo: this.regNo, prevName:'Student Profile',course:row.applicationDetails.course, session: sessionVal}]);
			}else{
				this.router.navigate(['/print/open/printAdmissionTransaction/'+ id , {prev:'/fee/feeProfile/'+this.studentId, regNo: this.regNo, prevName:'Fee Profile',course:row.applicationDetails.course,type:this.type, session: sessionVal}]);
			}
			// window.open(this.service.browserDomain+ '/print/open/printAdmissionTransaction/'+ id , id);
		}
	  }
	  printSelectedTemplate(data){
		let sessionVal = this.selectedSession || data.session;
		this.router.navigate(['/print/open/printReceipt/'+ data._id , {prev:'/student/studentProfile/'+this.studentId, regNo: this.regNo, prevName:'Student Profile',course:data.studentDetails.course, session: sessionVal}]);
		return;
	  }
	  viewRefundTransection(row){
		let sessionVal = this.selectedSession || row.session;
		this.router.navigate(['/print/open/printRefundTransactionReceipt/'+ row._id , {prev:'/fee/refundTransactionList', prevName:'Refund Transaction List',course:row.studentDetails.course, session: sessionVal}]);
	  }
	  viewDocument(url)
	  {
		window.open(url,  "_blank");
	  }
	setPaginator() {
	  this.dataSource.paginator = this.paginator1;
	  this.dataSource.sort = this.sort;
	  this.dataSource1.paginator = this.paginator2;
	  this.dataSource1.sort = this.sort;
	  this.dataSource2.paginator = this.paginator3;
	}
  
	checkPermission(value) {
	  return this.permissions.includes(value);
	}
}
